// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.Page
import org.mifos.mobile.core.model.entity.accounts.share.ShareAccountWithAssociations
import org.mifos.mobile.core.model.entity.payload.ShareApplicationPayload
import org.mifos.mobile.core.model.entity.templates.shareProductDetails.ShareProductDetails
import org.mifos.mobile.core.model.entity.templates.shares.ShareProduct

@OptIn(InternalKtorfitApi::class)
public class _ShareAccountServiceImpl(
  private val _ktorfit: Ktorfit,
) : ShareAccountService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getShareProducts(clientId: Long?): Flow<Page<ShareProduct>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "products/share")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<Page<ShareProduct>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getShareProductById(productId: Long, clientId: Long?): Flow<ShareProductDetails> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "products/share/${"$productId".encodeURLPath()}")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<ShareProductDetails>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun submitShareApplication(payload: ShareApplicationPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "shareaccounts")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override fun getShareAccountDetails(accountId: Long, associations: String): Flow<ShareAccountWithAssociations> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "shareaccounts/${"$accountId".encodeURLPath()}")
        associations?.let{ parameter("associations", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<ShareAccountWithAssociations>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _ShareAccountServiceProvider : ClassProvider<ShareAccountService> {
  override fun create(_ktorfit: Ktorfit): ShareAccountService = _ShareAccountServiceImpl(_ktorfit)
}

public fun Ktorfit.createShareAccountService(): ShareAccountService = _ShareAccountServiceImpl(this)
